import React, { ComponentProps } from 'react';
import { Text, VStack } from '@gluestack-ui/themed';
import ContentGroup from '@/common/components/ContentGroup';

type SettingsGroupCardProps = ComponentProps<typeof VStack> & {
  title?: string;
  children: React.ReactNode;
  bg?: string;
};

/**
 * SettingsGroupCard - Form section wrapper using ContentGroup.
 * Provides optional title and bordered variant for form layouts.
 */
const SettingsGroupCard = ({
  title, children, bg = '$bgCard', ...props
}: SettingsGroupCardProps) => (
  <VStack space="sm" {...props}>
    {!!title && (
      <Text size="sm" fontWeight="medium" color="$textSubtle" letterSpacing={0.3}>
        {title}
      </Text>
    )}
    <ContentGroup variant="bordered" bg={bg} p="$5" accentWidth={4}>
      {children}
    </ContentGroup>
  </VStack>
);

export default SettingsGroupCard;
